import { render, staticRenderFns } from "./DetailHistory.vue?vue&type=template&id=c3116066&scoped=true"
import script from "./DetailHistory.vue?vue&type=script&lang=js"
export * from "./DetailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3116066",
  null
  
)

export default component.exports